import React from 'react'
import './deliveryItem.css'

const DeliveryItem = ({item}) => {
  return (
    <div className='image-text-center'>
        <div className="delivery-item-cover" >
            <img src={item.cover} className="delivery-item-image"  alt={item.title}/>
        </div>
        <div className='delivery-item-title'>{item.title} </div>
    </div>
  )
}

export default DeliveryItem